import * as XLSX from 'xlsx';
import * as XLSXStyle from 'xlsx-style';

import { lazyInject } from '../../services/inversify';
import { ApiService } from '../../services/api_service';
import { DataService } from '../../services/data_service';
import * as Moment from 'moment';
import { Base64 } from 'js-base64';
import { saveAs } from 'file-saver';
import { getTextFromElement } from '../table/helpers/getTextFromElement';

export class ExcelTool {

    @lazyInject(ApiService) private apiService: ApiService;
    @lazyInject(DataService) private dataService: DataService;

    private debug = false;

    public getWorkbook(data: string, type?: any, opts?: XLSX.ParsingOptions): XLSX.WorkBook {
        // type = "string" | "binary" | "base64" | "buffer" | "file" | "array"
        try {
            const workbook = XLSX.read(data, { type: type ? type : 'binary', ...(opts ? opts : {}) });
            return workbook;
        } catch (e) {
            // console.log(e);
        }

    }
    public getSheetNames(workbook: XLSX.WorkBook) {
        const sheets = workbook.SheetNames;
        return sheets.map((sheet) => sheet.toString());
    }
    public getJSON(workbook: XLSX.WorkBook, sheetName: string, header?: any, opts?: XLSX.Sheet2JSONOpts) {
        if (!header) {
            header = 1;
        }
        const sheet = workbook.Sheets[sheetName];
        const sheet_json = XLSX.utils.sheet_to_json(sheet, { header: header, ...(opts ? opts : {}) });
        return sheet_json;
    }
    public getJSONAll(workbook: XLSX.WorkBook, parseData?: boolean) {
        const sheetNames = workbook.SheetNames;
        const sheetData: any = {};
        sheetNames.forEach((sn: string) => {
            sheetData[sn] = XLSX.utils.sheet_to_json(workbook.Sheets[sn], { header: 1, raw: !parseData });
        });
        return sheetData;
    }
    public dataToWb(title: string, columnsR: any[], dataR: any[], sheetName?: string,
        formatCallback?: (wb: XLSX.WorkSheet) => void, exportOptions?: any) {
        // dataR = JSON.parse(JSON.stringify(dataR)); // Fehler: Uncaught TypeError: Converting circular structure to JSON
        const wb = XLSX.utils.book_new();
        const ws = this.dataToSheet(columnsR, dataR, exportOptions);
        if (formatCallback) {
            formatCallback(ws);
        }
        if (!title || title === '') {
            title = 'export';
        }
        const filename = title + '.xlsx';
        const ws_name = sheetName ? sheetName : 'export';
        XLSX.utils.book_append_sheet(wb, ws, ws_name);
        // XLSX.writeFile(wb, filename, { cellStyles: true });
        const wopts = { bookType: 'xlsx', bookSST: false, type: 'binary' };
        const wbout = XLSXStyle.write(wb, wopts);
        saveAs(new Blob([this.s2ab(wbout)], { type: '' }), filename);
        return wb;
    }
    public dataMultiToWb(title: string, columns: Array<any[]>, data: Array<any[]>, sheetNames?: Array<string>,
        formatCallback?: (wb: XLSX.WorkSheet) => void, exportOptions?: any) {

        const wb = XLSX.utils.book_new();
        for (let i = 0; i < data.length; i++) {
            const columnsR = columns[i];
            const dataR = data[i];
            const sheetName = sheetNames[i];
            const ws = this.dataToSheet(columnsR, dataR, exportOptions);
            if (formatCallback) {
                formatCallback(ws);
            }
            if (!title || title === '') {
                title = 'export';
            }
            let ws_name = sheetName ? sheetName : 'export';
            ws_name = ws_name.replace('\\', '').replace('/', '').replace('?', '').replace('*', '').replace('[', '').replace(']', '');
            console.log('Daten Export: ', ws_name);
            XLSX.utils.book_append_sheet(wb, ws, ws_name);
        }
        const filename = title + '.xlsx';
        // XLSX.writeFile(wb, filename, { cellStyles: true });
        const wopts = { bookType: 'xlsx', bookSST: false, type: 'binary' };
        const wbout = XLSXStyle.write(wb, wopts);
        const ab = this.s2ab(wbout);
        console.log('RangeError?: ', ab.byteLength);
        // saveAs(new Blob([ab], { type: '' }), filename);
        const uint_arr = new Uint8Array(ab);
        // const str = String.fromCharCode.apply(null, uint_arr);
        let str = '';
        for (let j = 0; j < uint_arr.byteLength; j++) {
            str += String.fromCharCode(uint_arr[j]);
        }
        return btoa(str);
    }

    public dataToSheet(columnsR: any[], data_orig: any[], exportOptions?: any) {
        // console.log('SHEET', columnsR, data_orig);
        if (this.debug) { console.log('excel_tool dataToSheet-Data', columnsR, data_orig); }
        // sort dataR
        const dataR: Array<any> = [];
        for (let i = 0; i < data_orig.length; i++) {
            const sorted: any = {};
            columnsR.forEach((col) => {
                let val = data_orig[i][col.accessor];
                if (val && typeof val === 'object') {
                    val = getTextFromElement(val);
                }
                sorted[col.accessor] = val;
            });
            dataR[i] = sorted;
        }
        // console.log(data_orig, dataR);
        // entferne alle versteckten Spalten
        columnsR.forEach((col, idx, obj) => {
            if (col.accessor === 'tid' || (col.accessor === 'parent' && !col.excel_export)) {
                for (let i = 0; i < dataR.length; i++) {
                    delete dataR[i][col.accessor];
                }
                obj.splice(idx, 1);
            }
        });

        const colNames = dataR.length > 0 ? Object.keys(dataR[0]) : [];
        colNames.forEach((name) => {
            if (name.endsWith('_orig')) {
                for (let i = 0; i < dataR.length; i++) {
                    delete dataR[i][name];
                }
            }
        });

        if (this.debug) { console.log('excel_tool dataToSheet dataR after removing hidden and sorting-Data', dataR); }

        // const colTitles: any = [];
        // colNames.forEach((name) => {
        //     colTitles.push(this.dataToSheet_getColTitle(name, columnsR));
        // });

        const colHeaderRows: any = this.dataToSheet_getColHeaderRows(colNames, columnsR);


        // add Aggregations- Footer
        // ---> FOOTER VOR DER FORMATIERUNG!
        const dataR_map: any = {};
        dataR_map['data'] = dataR.map(o => { return { _original: o }; });
        const footer: any = {};
        columnsR.forEach((col) => {
            if (col.show !== false && col.accessor !== 'tid' && !(col.accessor === 'parent' && !col.excel_export)) {
                if (col.Footer instanceof Function && col.accessor !== 'a') {
                    // true ist das Export-Flag
                    footer[col.accessor] = col.Footer(dataR_map, true);
                } else {
                    footer[col.accessor] = '';
                }
            }
        });


        // Die Spaltendefinition wird mittels structure_tool und structure_service aufgebaut.
        // Dort bekommen Spalten, wenn Sie Typen haben die umgewandelt werden sollen, eine Cell-Function.
        // Wenn Spaltendefinition eine Cell-Function enthält, wird diese hier auf den Rohwert angewendet.
        columnsR.forEach((col) => {
            if (col.Cell instanceof Function && col.accessor !== 'a') {
                dataR.forEach((row) => {
                    if (col.type === 'DATE') {
                        if (row[col.accessor] !== 0) {
                            // Wir müssen uns um die Zeitzone kümmern.
                            const unix = Moment.unix(row[col.accessor]);
                            const tzOffset = Moment.parseZone(unix).utcOffset();
                            row[col.accessor] = (row[col.accessor] + tzOffset * 60) / 86400 + 25569;
                        }
                    } else if (col.type === 'FILE' || col.field_group === 'Fotos') { // Foto
                        row[col.accessor] = row[col.accessor] > 0 ? 'vorhanden' : '';
                    } else if (col.type === 'TEXT' && col.accessor === 'gallery_key') { // Gallery
                        row[col.accessor] = row[col.accessor] ? 'vorhanden' : '';
                    } else if (col.type !== 'DOUBLE') {
                        // Wir formatieren DOUBLE unmittelbar in Excel.
                        row[col.accessor] = col.Cell({ value: row[col.accessor] }, true); // true ist das Export-Flag
                    }
                });
            }
        });

        // Footer am Ende einfügen -> hier nicht, wurde neu angepasst
        // dataR.push(footer);

        const data = dataR.map(o => (Object as any).values(o));

        // dataR.pop(); // Die letzte Zeile in dataR wurde nur zur Erzeugung der Footerzeile angelegt und muss wieder raus

        colHeaderRows.reverse().forEach((ctr: Array<String>) => data.unshift(ctr));

        const footerRow = (Object as any).values(footer);
        if (footerRow.length > 0) {
            if (exportOptions && exportOptions.footerOverHeader) {
                data.unshift(footerRow);
            } else {
                data.push(footerRow);
            }
        }

        if (this.debug) {
            console.log(colHeaderRows);
            console.log(data);
        }

        const ws = XLSX.utils.aoa_to_sheet(data, { cellDates: true });
        ws['!cols'] = [];
        colNames.forEach(colName => {
            const wpx = this.dataToSheet_getColWidth(colName, columnsR);
            ws['!cols'].push({ wpx });
        });

        if (this.debug) {
            console.log('worksheet : ');
            console.log(ws);
            console.log('worksheet cols: ');
            console.log(ws['!cols']);
        }

        const range = XLSX.utils.decode_range(ws['!ref']);
        const rangeLength = range.e.r;
        const headerLength = colHeaderRows.length;
        columnsR.forEach((col, idx) => {
            let posHeader = 0;
            if (footerRow.length > 0 && exportOptions && exportOptions.footerOverHeader) {
                posHeader = 1;
            }
            // Kopfzeilen
            for (let i = posHeader; i < posHeader + headerLength; i++) {
                const cell = ws[XLSX.utils.encode_cell({ r: i, c: idx })];
                if (cell) {
                    cell.classname = 'header';
                }
            }
            // The Excel Data Type of the cell.
            // b Boolean, n Number, e Error, s String, d Date, z Empty
            if (col.type === 'INT') {
                for (let i = posHeader + headerLength; i < rangeLength; i++) {
                    const cell = ws[XLSX.utils.encode_cell({ r: i, c: idx })];
                    if (cell) {
                        // Bei Katalogen wird der numerische Wert durch Name ersetzt.
                        if (cell.v && !isNaN(parseInt(cell.v, 10))) {
                            cell.t = 'n';
                            cell.z = '0';
                        }
                    }
                }
            } else if (col.type === 'DOUBLE') {
                for (let i = posHeader + headerLength; i < rangeLength; i++) {
                    const cell = ws[XLSX.utils.encode_cell({ r: i, c: idx })];
                    if (cell) {
                        if (cell.v && !isNaN(parseFloat(cell.v))) {
                            cell.t = 'n';
                            cell.z = '#,##0.00';
                            if (col.format === 'EURO') {
                                cell.z = '#,##0.00 "€"';
                            }
                        }
                    }
                }
            } else if (col.type === 'DATE') {
                for (let i = posHeader + headerLength; i < rangeLength; i++) {
                    const cell = ws[XLSX.utils.encode_cell({ r: i, c: idx })];
                    if (cell) {
                        if (cell.v > 0) {
                            cell.z = 'DD.MM.YYYY';
                        } else {
                            cell.v = '';
                        }
                    }
                }
            }
        });

        return ws;
    }

    public dataToSheetToEmailOriginal(modul: string, title: string, columnsR: any[], dataR: any[], email: string, rawData: any) {
        const dataForSend = Base64.btoa(rawData.raw);
        const filename = rawData.titel + '_export.xlsx';

        this.apiService.call(
            'sendExportMailOriginal',
            {
                module: modul,
                emailTo: email,
                filename: filename,
                file: dataForSend,
                override: 1
            },
            (data: any, suc: boolean) => {
                console.log('sendExportMail response data :');
                console.log(data);
                const response = JSON.parse(data);
                if (response.success) {
                    /* this.dataService.afterSaveRessource(rawData.titel, rawData.structureKey, modul,
                     () => {}, true);
                     */
                    alert('Tabelle als File gespeichert und an ' + response.email + ' gesendet!');
                } else {
                    alert('Export als Email fehlgeschlagen : ' + response.error);
                }
            }
        );
    }

    public dataToSheetToEmail(module: string, title: string, columnsR: any[], dataR: any[], email: string,
        formatCallback?: (wb: XLSX.WorkSheet) => void) {
        const wb = this.dataToWb(title, columnsR, dataR, 'export', formatCallback);
        // const content = XLSX.write(wb, { type: 'base64', bookType: 'xlsx', bookSST: false });
        const content = XLSXStyle.write(wb, { type: 'base64', bookType: 'xlsx', bookSST: false });
        const dateStr = Moment(Moment.now()).format('YYYY-MM-DD');
        const filename = dateStr + '_' + title + '_Export.xlsx';
        this.apiService.call(
            'sendExportMail',
            { module: module, emailTo: email, content: content, filename: filename, override: 1 },
            (data: any, suc: boolean) => {
                console.log('sendExportMail response data :');
                console.log(data);
                const response = JSON.parse(data);
                if (response.success) {
                    alert('Tabelle als Datei gespeichert und an ' + response.email + ' gesendet!');
                } else {
                    alert('Export als Email fehlgeschlagen : ' + response.error);
                }
            }
        );
    }


    blobify(data: any) {
        if (typeof data === 'string') { return this.s2ab(data); }
        return data;
    }
    s2ab(s: any) {
        const buf = new ArrayBuffer(s.length), view = new Uint8Array(buf);
        for (let i = 0; i !== s.length; ++i) {
            view[i] = s.charCodeAt(i) & 0xFF;
        }
        return buf;
    }

    public saveOriginal(rawData: any) {
        const dataForSave = rawData.raw;
        const blob = new Blob([this.blobify(dataForSave)], { type: 'application/octet-stream' });
        const url = URL.createObjectURL(blob);
        // const a = document.createElement('a');
        // a.download = rawData.titel + '_export.xlsx';
        // a.href = url;
        // document.body.appendChild(a);
        // a.click();
        // document.body.removeChild(a);
        saveAs(url, rawData.titel + '_export.xlsx');
    }

    private dataToSheet_getColHeaderRows(colNames: Array<string>, columnsDef: any[]) {
        const colHeaderRows: Array<any> = [];
        let level = 0;
        let depth = 1;
        while (level < depth) {
            const titRow: Array<String> = [];
            colNames.forEach((cn: string) => {
                columnsDef.forEach(function (d: any) {
                    if (d.accessor === cn) {
                        let tit = '';
                        if (Array.isArray(d.HeaderExport) && d.HeaderExport.length > 0) {
                            tit = d.HeaderExport[level];
                            depth = Math.max(depth, d.HeaderExport.length);
                        } else if (level === 0) {
                            tit = d.HeaderText || (typeof d.Header === 'string' && d.Header);
                        }
                        titRow.push(tit);
                    }
                });
            });
            colHeaderRows.push(titRow);
            level++;
        }
        return colHeaderRows;
    }

    // private dataToSheet_getColTitle(colName: string, columnsDef: any[]) {
    //     // console.log(columnsDef);
    //     columnsDef.forEach(function (o) {
    //         // console.log('getColTitle ' + o.accessor);
    //         if (o.accessor === colName) {
    //             colName = o.HeaderText || (typeof o.Header === 'string' && o.Header);
    //             return;
    //         }
    //     });
    //     return colName;
    // }

    private dataToSheet_getColWidth(colName: string, columnsDef: any[]) {
        let colWidth = 50;
        columnsDef.forEach(function (o) {
            // console.log('getColTitle ' + o.accessor);
            if (o.accessor === colName && typeof o.width !== 'undefined') {
                colWidth = o.width;
                return;
            } else if (o.accessor === colName) {
                colWidth = 120;
                return;
            }
        });
        return colWidth;
    }


}
